package co.uk.sacursoftware.ssinventory.data.remote

import io.ktor.client.*
import io.ktor.client.engine.js.*

actual fun createHttpClient(): HttpClient = configureClient(HttpClient(Js))
